import { doc, getDoc, type Firestore } from 'firebase/firestore';

/**
 * Resolves which enhancedDeals document should be marked won when a proposal is signed.
 * Proposal builder docs live at proposalBuilders/{proposalDocId}. Normally proposalDocId
 * equals the deal id; if the stored `dealId` field drifted, prefer the doc id when that
 * deal exists so CRM (which loads proposalBuilders/deal.id) stays consistent.
 */
export async function resolveEnhancedDealIdForProposalDoc(
  db: Firestore,
  proposalDocId: string,
  dealIdField: string | undefined | null,
): Promise<string | null> {
  const byDoc = await getDoc(doc(db, 'enhancedDeals', proposalDocId));
  if (byDoc.exists()) {
    if (dealIdField && dealIdField !== proposalDocId) {
      console.warn(
        `[proposal] dealId field (${dealIdField}) does not match proposal doc id (${proposalDocId}); using doc id for CRM.`,
      );
    }
    return proposalDocId;
  }
  if (dealIdField && dealIdField !== proposalDocId) {
    const byField = await getDoc(doc(db, 'enhancedDeals', dealIdField));
    if (byField.exists()) {
      console.warn(
        `[proposal] No enhancedDeals/${proposalDocId}; using dealId field enhancedDeals/${dealIdField} (legacy).`,
      );
      return dealIdField;
    }
  }
  return null;
}
